import { OpinionPollItem } from '@/modules/opinions';
import { SearchData } from '@/utils';
import { makeAutoObservable } from 'mobx';

export class UgcStore {
  public currentSubmissionId: string = '';
  public suggestedText: string = '';
  public image: string | null = null;
  public imageFile: File | null = null;
  public opinionType: 'single' | 'multiple' = 'single';
  public opinionIsPrivate: boolean = false;
  public opinionAnswers: OpinionPollItem[] = [
    { title: '', itemId: Date.now().toString() },
  ];

  public currentTournamentSubmissionId: string = '';
  public tournamentTitle: string = '';
  public tournamentDescription: string = '';
  public tournamentImage: string | null = null;
  public tournamentImageFile: File | null = null;
  public tournamentOpinions: SearchData[] = [];
  public tournamentBudget: Map<string, string> = new Map();
  public tournamentTicketCosts: Map<string, string> = new Map();
  public tournamentSubmissionDraftData: string = '';
  public tournamentIsPrivate: boolean = false;

  public pollTitle: string = '';
  public pollAnswers: OpinionPollItem[] = [
    { title: '', itemId: Date.now().toString() },
  ];
  public pollImage: string | null = null;
  public pollImageFile: File | null = null;
  public currentPollSubmissionId: string = '';

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public setOpinionType(type: 'single' | 'multiple') {
    this.opinionType = type;
  }

  public setImage(image: string | null) {
    this.image = image;
  }

  public setPollImage(image: string | null) {
    this.pollImage = image;
  }

  public setImageFile(image: File | null) {
    this.imageFile = image;
  }

  public setPollImageFile(image: File | null) {
    this.pollImageFile = image;
  }

  public setTournamentImageFile(image: File | null) {
    this.tournamentImageFile = image;
  }

  public setTournamentImage(image: string | null) {
    this.tournamentImage = image;
  }

  public setCurrentSubmissionId(id: string) {
    this.currentSubmissionId = id;
  }

  public setCurrentTournamentSubmissionId(id: string) {
    this.currentTournamentSubmissionId = id;
  }

  public setCurrentPollSubmissionId(id: string) {
    this.currentPollSubmissionId = id;
  }

  public setSuggestedText = (text: string) => {
    this.suggestedText = text;
  };

  public setTournamentTitle = (text: string) => {
    this.tournamentTitle = text;
  };

  public setTournamentDescription = (text: string) => {
    this.tournamentDescription = text;
  };

  public addTournamentOpinion(opinion: SearchData) {
    const exists = this.tournamentOpinions.some((o) => o._id === opinion._id);
    if (!exists) {
      this.tournamentOpinions = [...this.tournamentOpinions, opinion];
    }
  }

  public removeTournamentOpinion(opinion: SearchData) {
    this.tournamentOpinions = this.tournamentOpinions.filter(
      (o) => o._id !== opinion._id,
    );
  }

  public setTournamentBudget(
    valueOrUpdater:
      | Map<string, string>
      | ((prev: Map<string, string>) => Map<string, string>),
  ) {
    this.tournamentBudget =
      typeof valueOrUpdater === 'function'
        ? valueOrUpdater(this.tournamentBudget)
        : valueOrUpdater;
  }

  public setTournamentTicketCosts(
    valueOrUpdater:
      | Map<string, string>
      | ((prev: Map<string, string>) => Map<string, string>),
  ) {
    this.tournamentTicketCosts =
      typeof valueOrUpdater === 'function'
        ? valueOrUpdater(this.tournamentTicketCosts)
        : valueOrUpdater;
  }

  public setTournamentSubmissionDraftData(value: string) {
    this.tournamentSubmissionDraftData = value;
  }

  public clearPollStoreData() {
    this.currentPollSubmissionId = '';
    this.pollTitle = '';
    this.pollImage = null;
    this.pollImageFile = null;
    this.pollAnswers = [];
  }

  public clearOpinionStoreData() {
    this.currentSubmissionId = '';
    this.suggestedText = '';
    this.imageFile = null;
    this.image = null;
    this.opinionType = 'single';
    this.opinionIsPrivate = false;
    this.opinionAnswers = [];
  }

  public clearSubmissionStoreData() {
    this.currentTournamentSubmissionId = '';
    this.tournamentTitle = '';
    this.tournamentDescription = '';
    this.tournamentImage = null;
    this.tournamentImageFile = null;
    this.tournamentOpinions = [];
    this.tournamentBudget = new Map();
    this.tournamentTicketCosts = new Map();
    this.tournamentSubmissionDraftData = '';
    this.tournamentIsPrivate = false;
  }

  public setTournamentIsPrivate(value: boolean) {
    this.tournamentIsPrivate = value;
  }

  public setOpinionIsPrivate(value: boolean) {
    this.opinionIsPrivate = value;
  }

  public setPollTitle(value: string) {
    this.pollTitle = value;
  }

  public setPollAnswers(answers: OpinionPollItem[]) {
    this.pollAnswers = answers;
  }

  public setOpinionAnswers(answers: OpinionPollItem[]) {
    this.opinionAnswers = answers;
  }
}
